import { EfsMelcoEfsModelsMappingFileAttribute } from "melco-shared-logic";
import { FilenameRuleFormMode } from "../../components/inputFormats/FilenameRuleDrawer";

type FilenameRuleConstraint = "scopedPrefix" | "scopedSuffix";

export const useFilenameRulesValidation = (
  formMode: FilenameRuleFormMode,
  type: string,
  filenameRules: EfsMelcoEfsModelsMappingFileAttribute[]
) => {
  const violatedConstraints: FilenameRuleConstraint[] = [];

  if (formMode === "edit") {
    // no need to validate in edit mode as you can't change the scope type
    return [];
  }

  const existingScopedSuffixRule = filenameRules.find(
    (fr) => fr.type === "ScopedSuffix"
  );

  // adding
  if (existingScopedSuffixRule) {
    violatedConstraints.push("scopedSuffix");
  } else if (type === "ScopedPrefix" && filenameRules.length > 0) {
    violatedConstraints.push("scopedPrefix");
  }

  return violatedConstraints;
};
